
/**
 * Module dependencies.
 */

import { CollectionProps } from 'src/types/collection';
import { availableFiltersKeys } from 'src/core/collections-config/filters';
import ApplicationFilter from 'src/components/collections/filters-list/application-filter';
import BaseFiltersSidebar from 'src/components/filters/filters-sidebar';
import CollectionFilter from 'src/components/collections/filters-list/collection-filter';
import ColorFilter from 'src/components/collections/filters-list/color-filter';
import EffectFilter from 'src/components/collections/filters-list/effect-filter';
import FinishFilter from 'src/components/collections/filters-list/finish-filter';
import FormatFilter from 'src/components/collections/filters-list/format-filter';
import HueVariationFilter from 'src/components/collections/filters-list/hue-variation-filter';
import React, { ReactElement } from 'react';
import RecycleMaterialFilter from 'src/components/collections/filters-list/recycle-material-filter';
import SlipResistanceFilter from 'src/components/collections/filters-list/slip-resistance-filter';
import ThicknessFilter from 'src/components/collections/filters-list/thickness-filter';
import TrafficLevelFilter from 'src/components/collections/filters-list/traffic-level-filter';
import TypologyFilter from 'src/components/collections/filters-list/typology-filter';
import filter from 'lodash/filter';
import useAllCollections from 'src/api/app/collections/use-all-collections';

/**
 * `Props` type.
 */

type Props = {
  isOpen: boolean,
  isUpdating: boolean,
  onClose: () => void,
  onUpdate: () => void
}

/**
 * `FiltersSidebar` component.
 */

const FiltersSidebar = (props: Props): ReactElement => {
  const { isOpen, isUpdating, onClose, onUpdate } = props;
  const { data, isLoading, isSuccess } = useAllCollections<CollectionProps[]>();

  return (
    <BaseFiltersSidebar
      isOpen={isOpen}
      isUpdating={isUpdating}
      onClose={onClose}
      onUpdate={onUpdate}
    >
      <CollectionFilter
        collections={data ?? []}
        filterName={availableFiltersKeys.collectionsAll}
        isLoading={isLoading}
        isSuccess={isSuccess}
        type={'all'}
      />

      <CollectionFilter
        collections={filter(data, { new: true }) ?? []}
        filterName={availableFiltersKeys.collectionsNew}
        isLoading={isLoading}
        isSuccess={isSuccess}
        type={'new'}
      />

      <ApplicationFilter filterName={availableFiltersKeys.application} />

      <EffectFilter filterName={availableFiltersKeys.effect} />

      <ColorFilter />

      <FormatFilter />

      <FinishFilter />

      <TypologyFilter />

      <ThicknessFilter />

      <HueVariationFilter />

      <TrafficLevelFilter />

      <RecycleMaterialFilter />

      <SlipResistanceFilter />
    </BaseFiltersSidebar>
  );
};

/**
 * Export `FiltersSidebar` component.
 */

export default FiltersSidebar;
